





































































































































































































































































































































































































































































































































































import { Vue, Component, InjectReactive, Watch } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { v4 as uuid } from 'uuid';
import { AgGridVue } from '@ag-grid-community/vue';
import { GridReadyEvent, ValueGetterParams } from '@ag-grid-community/core';
import Tooltip from '@/components/tooltip.vue';
import DateRangeFilter from '@/components/date-range-filter.vue';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import AttendanceService from '@/services/crm/attendance.service';
import EngagementScoreService from '@/services/crm/engagement-score.service';
import RouterService from '@/services/router.service';
import AttendanceModel from '@/models/crm/attendance.model';
import EngagementScoreModel from '@/models/crm/engagement-score.model';
import { AttendanceOriginEnum } from '@/enums/crm/attendance-origin.enum';
import { IKeyValue } from '@/interfaces/key-value.interface';
import { IDialogConfig } from '@/interfaces/dialog-config.interface';
import { IDateRangeConfig } from '@/interfaces/date-range-config.interface';
import ContentDialog from '@/components/content-dialog.vue';
import AgGridWrapper from '@/components/ag-grid-wrapper.vue';
import { GridHelper } from '@/utils/helpers/grid-helper';
import { DateHelper } from '@/utils/helpers/date-helper';

import dayjs from '@/plugins/dayjs';
import { ClientTypeEnum } from '@/enums/client-type.enum';
import ClientModel from '@/models/crm/client.model';
import CrmChatHistoryMessagesViewer from '@/components/crm/chat-history-messages-viewer.vue';
import CrmEvoTalksChatHistoryViewer from '@/components/crm/crm-evotalks-chat-history-viewer.vue';
import CRMEvoTalksService from '@/services/crm/evotalks.service';
import EvoTalksConversaResumoModel from '@/models/crm/evotalks-conversa-resumo.model';
import CrmOrderDetails from '@/components/crm/order-details.vue';
import CrmOrderEmailView from '@/components/crm/order-email-view.vue';
import ConversationModel from '@/models/crm/conversation.model';
import ConversationService from '@/services/crm/conversation.service';
import ProcessService from '@/services/crm/process.service';
import ProcessModel from '@/models/crm/process.model';
import OrderService from '@/services/crm/order.service';
import OrderModel from '@/models/crm/order.model';
import UserContactInfo from '@/models/crm/user-contact-info.model';
import CallCenterCallModel from '@/models/crm/call-center-call.model';
import CallCenterCallService from '@/services/crm/call-center-call.service';
import AttendanceEngagementCard from '@/components/crm/attendance-engagement-card.vue';
import AttendanceStatsCard from '@/components/crm/attendance-stats-card.vue';
import AttendanceSummaryModel from '@/models/crm/attendance-summary.model';

type DataGridFilterConfig = {
  keyword: string | undefined;
  issuance: (Date | undefined)[];
  origins: AttendanceOriginEnum[];
};

@Component({
  components: {
    Tooltip,
    ContentDialog,
    AgGridWrapper,
    AgGridVue,
    CrmChatHistoryMessagesViewer,
    CrmEvoTalksChatHistoryViewer,
    CrmOrderDetails,
    CrmOrderEmailView,
    DateRangeFilter,
    AttendanceEngagementCard,
    AttendanceStatsCard,
  },
})
export default class CrmAttendance extends Vue {
  @inject(InjectionIdEnum.CrmAttendanceService)
  private attendanceService!: AttendanceService;

  @inject(InjectionIdEnum.RouterService)
  private routerService!: RouterService;

  @inject(InjectionIdEnum.CrmConversationService)
  private conversationService!: ConversationService;

  @inject(InjectionIdEnum.CRMEvoTalksService)
  private evoTalksService!: CRMEvoTalksService;

  @inject(InjectionIdEnum.CrmProcessService)
  private processService!: ProcessService;

  @inject(InjectionIdEnum.CrmOrderService)
  private orderService!: OrderService;

  @inject(InjectionIdEnum.CallCenterCallService)
  private callCenterCallService!: CallCenterCallService;

  @inject(InjectionIdEnum.CrmEngagementScoreService)
  private engagementScoreService!: EngagementScoreService;

  @InjectReactive('activeClient') readonly activeClient!: ClientModel;

  @InjectReactive('userContactInfo') readonly userContactInfo!: UserContactInfo;

  @InjectReactive('clientType') readonly clientType!: ClientTypeEnum;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  attendanceOriginEnum = AttendanceOriginEnum;

  items: AttendanceModel[] = [];

  engagementScore: EngagementScoreModel | null = null;

  attendanceSummary: AttendanceSummaryModel | null = null;

  emptyItems = false;

  loadingItems = false;

  filters: DataGridFilterConfig = {
    keyword: undefined,
    issuance: [undefined, undefined],
    origins: Object.values(AttendanceOriginEnum) as AttendanceOriginEnum[],
  };

  private keywordDebounceTimer: ReturnType<typeof setTimeout> | null = null;

  @Watch('filters.keyword')
  onKeywordChange(): void {
    if (this.keywordDebounceTimer) clearTimeout(this.keywordDebounceTimer);
    this.keywordDebounceTimer = setTimeout(() => {
      this.reloadAfterKeywordChange();
    }, 500);
  }

  async reloadAfterKeywordChange(): Promise<void> {
    this.items = [];
    this.page = 0;
    this.noMoreItems = false;
    this.emptyItems = false;
    await this.loadItems(false);
  }

  expandedItems: IKeyValue<boolean> = {};

  loadingExpand: IKeyValue<boolean> = {};

  loadedCalls: IKeyValue<CallCenterCallModel | null> = {};

  noMoreItems = false;

  processes: ProcessModel[] = [];

  predefinedIssuanceFilterRanges: IDateRangeConfig[] = this.getDateRanges();

  originProperty: IKeyValue<{ icon: string; label: string }> = {
    [AttendanceOriginEnum.Email]: {
      icon: 'mdi-email-outline',
      label: this.$t('crm.view.attendance.origin.email').toString(),
    },
    [AttendanceOriginEnum.Process]: {
      icon: 'mdi-sitemap',
      label: this.$t('crm.view.attendance.origin.process').toString(),
    },
    [AttendanceOriginEnum.Calendar]: {
      icon: 'mdi-calendar-month-outline',
      label: this.$t('crm.view.attendance.origin.calendar').toString(),
    },
    [AttendanceOriginEnum.Order]: {
      icon: 'mdi-cart',
      label: this.$t('crm.view.attendance.origin.order').toString(),
    },
    [AttendanceOriginEnum.Conversation]: {
      icon: 'mdi-chat',
      label: this.$t('crm.view.attendance.origin.conversation').toString(),
    },
    [AttendanceOriginEnum.SurveyNPS]: {
      icon: 'mdi-star',
      label: this.$t('crm.view.attendance.origin.surveynps').toString(),
    },
    [AttendanceOriginEnum.Call]: {
      icon: 'mdi-phone',
      label: this.$t('crm.view.attendance.origin.call').toString(),
    },
    [AttendanceOriginEnum.Audio]: {
      icon: 'mdi-microphone',
      label: this.$t('crm.view.attendance.origin.audio').toString(),
    },
    [AttendanceOriginEnum.EvoTalks]: {
      icon: 'mdi-forum',
      label: this.$t('crm.view.attendance.origin.evotalks').toString(),
    },
  };

  dialogConfig: IKeyValue<IDialogConfig> = {
    chatHistory: {
      show: false,
      conversation: null,
    },
    evoChatHistory: {
      show: false,
      conversation: null,
    },
    orderDetail: {
      show: false,
      order: null,
    },
    sendOrderEmail: {
      show: false,
    },
  };

  grid: GridReadyEvent | null = null;

  gridColumnsDef = [
    {
      headerName: `${this.$t('crm.view.attendance.grid.date')}`,
      field: 'data',
      valueGetter: (params: ValueGetterParams): string => {
        const date = GridHelper.valueGetter(params);
        const time = params.data.hora;
        const value = dayjs(`${DateHelper.formatToIsoDateString(dayjs(date))}T${time}`);
        return DateHelper.formatToIsoDateTimeString(value);
      },
    },
    {
      headerName: `${this.$t('crm.view.attendance.grid.origin')}`,
      field: 'origem',
    },
    {
      headerName: `${this.$t('crm.view.attendance.grid.attendant')}`,
      field: 'nomeAtendente',
    },
    {
      headerName: `${this.$t('crm.view.attendance.grid.title')}`,
      field: 'titulo',
    },
    {
      headerName: `${this.$t('crm.view.attendance.grid.description')}`,
      field: 'descricao',
      valueGetter: (params: ValueGetterParams): string => {
        const regExp = new RegExp(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g);
        const value = GridHelper.valueGetter(params);
        return value ? value.replace(regExp, ' ') : '';
      },
    },
  ];

  private index = '';

  private readonly itemsPerPage = 100;

  private page = 0;

  private sendOrderByEmailLimit = 10;

  ordersPeriod: OrderModel[] = [];

  ordersToSend: OrderModel[] = [];

  private getDateRanges(): IDateRangeConfig[] {
    return [
      {
        name: `${this.$t('global.currentMonth')}`,
        ...DateHelper.getCurrentMonthPeriod(),
      },
      {
        name: `${this.$t('global.lastMonth')}`,
        ...DateHelper.getLastMonthsPeriod(1),
      },
      {
        name: `${this.$t('global.lastThreeMonths')}`,
        ...DateHelper.getLastMonthsPeriod(3),
      },
      {
        name: `${this.$t('global.lastSixMonths')}`,
        ...DateHelper.getLastMonthsPeriod(6),
      },
      {
        name: `${this.$t('global.lastYear')}`,
        ...DateHelper.getLastYearsPeriod(1),
      },
      {
        name: `${this.$t('global.currentYear')}`,
        ...DateHelper.getCurrentYearPeriod(),
      },
    ];
  }

  created(): void {
    this.index = uuid();
  }

  private initialized = false;

  async mounted(): Promise<void> {
    if (this.activeClient) {
      await this.initView();
    }
  }

  @Watch('activeClient')
  async onActiveClientReady(value: ClientModel | null): Promise<void> {
    if (value && !this.initialized) {
      await this.initView();
    }
  }

  private async initView(): Promise<void> {
    if (this.initialized) return;
    this.initialized = true;

    const loader = this.$loading.show();
    const initialDate = dayjs().add(-30, 'day').toDate();
    const finalDate = dayjs().toDate();
    this.filters.issuance = [initialDate, finalDate];

    try {
      const isProspect = this.clientType === ClientTypeEnum.Prospect;
      const clientId = isProspect ? this.activeClient?.codCliente : this.activeClient?.cnpjCpf;

      const records = await this.attendanceService.generate(
        clientId || this.getClientIdFromRoute(),
        this.activeClient?.prospectId || null,
        this.clientType,
        this.index,
        dayjs(initialDate).format('DD/MM/YYYY'),
        dayjs(finalDate).format('DD/MM/YYYY'),
      );

      const clientId2 = (
        this.clientType === ClientTypeEnum.Prospect
          ? this.activeClient?.codCliente
          : this.activeClient?.cnpjCpf
      )
        || this.getClientIdFromRoute();
      if (records) {
        this.ordersPeriod = records;
        await Promise.all([
          this.loadItems(false),
          this.loadSummary(clientId2),
        ]);
      } else {
        this.emptyItems = true;
        this.attendanceSummary = null;
      }
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      loader.hide();
    }

    await this.loadEngagementScore(
      (this.clientType === ClientTypeEnum.Prospect ? this.activeClient?.codCliente : this.activeClient?.cnpjCpf)
      || this.getClientIdFromRoute(),
    );

    await this.loadProcessFlows();
  }

  private async loadSummary(clientId: string): Promise<void> {
    try {
      this.attendanceSummary = await this.attendanceService.getSummary(clientId, this.clientType, this.index);
    } catch (err) {
      // summary não bloqueia
    }
  }

  applyQuickRange(range: IDateRangeConfig): void {
    this.filters.issuance = [range.start, range.end];
  }

  isRangeActive(range: IDateRangeConfig): boolean {
    const [s, e] = this.filters.issuance;
    return !!(s && e
      && (s as Date).getTime() === range.start.getTime()
      && (e as Date).getTime() === range.end.getTime());
  }

  private async loadEngagementScore(clientId: string): Promise<void> {
    try {
      this.engagementScore = await this.engagementScoreService.getEngagementScore(
        clientId,
        this.clientType,
        this.index,
      );
    } catch (err) {
      // Engagement score não bloqueia a tela principal
    }
  }

  // ─── Expand/Collapse

  // eslint-disable-next-line class-methods-use-this
  getExpandKey(item: AttendanceModel): string {
    return `${item.id}_${item.idPrincipal}`;
  }

  isExpanded(item: AttendanceModel): boolean {
    return !!this.expandedItems[this.getExpandKey(item)];
  }

  async toggleExpand(item: AttendanceModel): Promise<void> {
    if (item.origem === AttendanceOriginEnum.Conversation) {
      this.openHistoryConversationDialog(item.idPrincipal);
      return;
    }

    if (item.origem === AttendanceOriginEnum.EvoTalks) {
      await this.openEvoChatHistoryDialog(item.idPrincipal);
      return;
    }

    if (item.origem === AttendanceOriginEnum.Order) {
      await this.openOrderDetailDialog(item);
      return;
    }

    const key = this.getExpandKey(item);

    if (this.expandedItems[key]) {
      this.$set(this.expandedItems, key, false);
      return;
    }

    // Lazy-load LIGAÇÃO
    if (item.origem === AttendanceOriginEnum.Call && !this.loadedCalls[key]) {
      this.$set(this.loadingExpand, key, true);
      try {
        const call = await this.callCenterCallService.getById(item.idPrincipal);
        this.$set(this.loadedCalls, key, call);
      } catch (err) {
        this.$set(this.loadedCalls, key, null);
      } finally {
        this.$set(this.loadingExpand, key, false);
      }
    }

    this.$set(this.expandedItems, key, true);
  }

  // ─── Filtro por tipo de origem

  isOriginActive(origem: string): boolean {
    return this.filters.origins.includes(origem as AttendanceOriginEnum);
  }

  toggleOriginFilter(origem: string): void {
    const idx = this.filters.origins.indexOf(origem as AttendanceOriginEnum);
    if (idx >= 0) {
      this.filters.origins.splice(idx, 1);
    } else {
      this.filters.origins.push(origem as AttendanceOriginEnum);
    }
  }

  selectAllOrigins(): void {
    this.filters.origins = Object.values(AttendanceOriginEnum) as AttendanceOriginEnum[];
  }

  clearAllOrigins(): void {
    this.filters.origins = [];
  }

  countByOrigin(origem: string): number {
    if (this.attendanceSummary) {
      return this.attendanceSummary.countByOrigin[origem] || 0;
    }
    return this.items.filter((i) => i.origem === origem).length;
  }

  // ─── Métodos de UI existentes

  async onExport(): Promise<void> {
    if (!this.noMoreItems) {
      const loader = this.$loading.show();
      try {
        await this.loadRemainingItemsRecursively(500, this.page * this.itemsPerPage, 1);
      } catch (err) {
        this.$notify.error(err && (err as Error).message);
      } finally {
        loader.hide();
      }
    }

    if (this.grid) {
      this.grid.api.exportDataAsExcel({
        allColumns: true,
        author: 'IBtech',
        sheetName: 'Atendimentos',
        fileName: AttendanceService.generateAttendanceExportFilename(new Date()),
      });
    }
  }

  async openHistoryConversationDialog(id: number): Promise<void> {
    const loader = this.$loading.show();
    try {
      const conversation = await this.conversationService.getConversation(id, false);
      this.dialogConfig.chatHistory.conversation = conversation;
      this.dialogConfig.chatHistory.show = true;
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      loader.hide();
    }
  }

  async openOrderDetailDialog(selectedOrder: AttendanceModel): Promise<void> {
    const loader = this.$loading.show();
    try {
      if (this.ordersPeriod) {
        const filteredOrder = this.ordersPeriod.find((obj) => obj.codPedido === selectedOrder.descricao);
        if (filteredOrder) {
          const order = await this.orderService.getOrder(
            filteredOrder.idDataSource,
            filteredOrder.codEmpresa,
            filteredOrder.codPedido,
          );
          if (order) {
            this.dialogConfig.orderDetail.order = order;
            this.dialogConfig.orderDetail.show = true;
          }
        }
      }
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      loader.hide();
    }
  }

  onCloseChatHistoryDialogClose(): void {
    this.dialogConfig.chatHistory.show = false;
    this.dialogConfig.chatHistory.conversation = false;
  }

  async openEvoChatHistoryDialog(id: number): Promise<void> {
    const loader = this.$loading.show();
    try {
      const conversa = await this.evoTalksService.getResumoById(id);
      this.dialogConfig.evoChatHistory.conversation = conversa;
      this.dialogConfig.evoChatHistory.show = true;
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      loader.hide();
    }
  }

  onCloseEvoChatHistoryDialogClose(): void {
    this.dialogConfig.evoChatHistory.show = false;
    this.dialogConfig.evoChatHistory.conversation = null;
  }

  get viewTitle(): string {
    return this.$t('crm.view.attendance.title', { clientType: this.$t(`crm.${this.clientType}`) }).toString();
  }

  get orderDetailDialogTitle(): string {
    return `${this.$t('crm.view.order.dialog.details.title', {
      orderNumber:
        this.dialogConfig?.orderDetail?.order && (this.dialogConfig.orderDetail.order as OrderModel).codPedido,
    })}`;
  }

  get sendOrderEmailDialogTitle(): string {
    const orderNumber = this.ordersToSend.map((item) => `#${item.codPedido}`).join(', ');
    return `${this.$tc('crm.view.order.dialog.sendMail.title', this.ordersToSend.length, { orderNumber })}`;
  }

  get chatHistoryDialogTitle(): string {
    const protocol = (this.dialogConfig.chatHistory.conversation as ConversationModel)?.protocolo;
    return this.$t('crm.view.attendance.dialog.chatHistory.title', { protocol }).toString();
  }

  get evoChatHistoryDialogTitle(): string {
    const protocol = (this.dialogConfig.evoChatHistory.conversation as EvoTalksConversaResumoModel)?.protocolo;
    return this.$t('crm.view.attendance.dialog.chatHistory.title', { protocol }).toString();
  }

  get monthSeparator(): IKeyValue<string> {
    const data: IKeyValue<string> = {};
    let previousDate: dayjs.Dayjs;
    this.filteredItems.forEach((item, index) => {
      const currentDate = dayjs(item.data);
      if (index === 0) {
        data[index] = currentDate.format('MM/YYYY');
      } else if (previousDate.month() !== currentDate.month() || previousDate.year() !== currentDate.year()) {
        data[index] = currentDate.format('MM/YYYY');
      }
      previousDate = currentDate;
    });
    return data;
  }

  async loadItems(isInfiniteScrollingLoad: boolean): Promise<void> {
    if (isInfiniteScrollingLoad && (this.noMoreItems || this.loadingItems)) {
      return;
    }

    this.loadingItems = true;

    const offset = this.page * this.itemsPerPage;
    this.page += 1;
    const result = await this.loadData(this.itemsPerPage, offset);

    this.items.push(...result);

    if (result.length < this.itemsPerPage) {
      this.noMoreItems = true;
    }

    if (this.items.length === 0) {
      this.emptyItems = true;
    }

    this.loadingItems = false;
  }

  private async loadRemainingItemsRecursively(limit: number, startOffset: number, iteration: number): Promise<void> {
    this.loadingItems = true;

    const offset = (iteration - 1) * limit + startOffset;
    const result = await this.loadData(limit, offset);
    this.items = [...this.items, ...result];

    if (result.length === limit) {
      await this.loadRemainingItemsRecursively(limit, startOffset, iteration + 1);
    }

    this.loadingItems = false;
  }

  private async loadData(limit: number, offset: number): Promise<AttendanceModel[]> {
    const isProspect = this.clientType === ClientTypeEnum.Prospect;
    const clientId = isProspect ? this.activeClient?.codCliente : this.activeClient?.cnpjCpf;
    const initialDate = this.filters.issuance[0] ? this.filters.issuance[0] : dayjs().add(-30, 'day').toDate();
    const finalDate = this.filters.issuance[1] ? this.filters.issuance[1] : dayjs().toDate();

    const allOriginsCount = Object.values(AttendanceOriginEnum).length;
    const originsFilter = this.filters.origins.length < allOriginsCount ? this.filters.origins : undefined;

    const attendancesList = await this.attendanceService.get(
      clientId,
      this.clientType,
      this.index,
      limit,
      offset,
      dayjs(initialDate).format('DD/MM/YYYY'),
      dayjs(finalDate).format('DD/MM/YYYY'),
      originsFilter,
      this.filters.keyword,
    );

    return attendancesList.map((x) => {
      const item = x;
      item.hora = x.hora ? x.hora.substring(0, 5) : '';
      if (item.origem === AttendanceOriginEnum.Audio && item.audioUrl) {
        item.audioUrl = `${this.attendanceService.getApiPath()}/crm/upload/download/${item.audioUrl}`;
      }
      item.idRegistro = `${item.origem}${item.idRegistro}`;
      return item;
    });
  }

  private async loadProcessFlows(): Promise<void> {
    const isProspect = this.clientType === ClientTypeEnum.Prospect;
    const clientId = isProspect ? this.activeClient?.codCliente : this.activeClient?.cnpjCpf;
    this.processes = await this.processService.getProcesses(clientId, this.clientType);
  }

  get processesMap(): IKeyValue<ProcessModel> {
    return this.processes.reduce((acc, processo) => {
      if (processo.id != null) {
        // eslint-disable-next-line no-param-reassign
        acc[processo.id] = processo;
      }
      if (processo.idProcesso != null) {
        // eslint-disable-next-line no-param-reassign
        acc[processo.idProcesso] = processo;
      }
      return acc;
    }, {} as IKeyValue<ProcessModel>);
  }

  openProcessFromTimeline(item: AttendanceModel): void {
    const processo = this.processesMap[item.idPrincipal];
    if (!processo) {
      this.$notify.error(this.$t('crm.view.attendance.card.process.openError').toString());
      return;
    }
    try {
      const processId = processo.id || processo.idProcesso;
      if (processId) {
        if (ProcessService.isSalesFunnelFlow(processo.tipoFluxo)) {
          this.processService.openSalesFunnelProcess(processId, processo.fluxo);
          return;
        }

        if (this.processService.openProcessInGeoTab(processId, processo.idFluxo)) {
          return;
        }
      }

      const isProspect = this.clientType === ClientTypeEnum.Prospect;
      const clientId = (isProspect ? this.activeClient?.codCliente : this.activeClient?.cnpjCpf) || '';
      const url = this.processService.getNewKanbanUrl(
        processo.idFluxo,
        clientId,
        this.clientType,
        processo.idFila,
        processo.id || processo.idProcesso,
        true,
        undefined,
        true,
      );
      window.open(url, '_blank');
    } catch {
      this.$notify.error(this.$t('crm.view.attendance.card.process.openError').toString());
    }
  }

  get filteredItems(): AttendanceModel[] {
    return this.items;
  }

  get ordersMap(): IKeyValue<OrderModel> {
    return this.ordersPeriod.reduce((acc, o) => {
      // eslint-disable-next-line no-param-reassign
      acc[o.codPedido] = o;
      return acc;
    }, {} as IKeyValue<OrderModel>);
  }

  get activeFilters(): number {
    let active = 0;
    if (this.filters.keyword) active += 1;
    const allOriginsCount = Object.values(AttendanceOriginEnum).length;
    if (this.filters.origins.length < allOriginsCount) active += 1;
    if (this.filters.issuance && (this.filters.issuance[0] || this.filters.issuance[1])) active += 1;
    return active;
  }

  async onSearch(): Promise<void> {
    const loader = this.$loading.show({
      container: this.$refs.loadAttendanceContainer,
      canCancel: false,
      height: 25,
    });
    try {
      this.items = [];
      this.page = 0;
      this.noMoreItems = false;
      this.emptyItems = false;
      const id = this.clientType === ClientTypeEnum.Prospect
        ? this.activeClient?.codCliente
        : this.activeClient?.cnpjCpf;
      const initialDate = this.filters.issuance[0] ? this.filters.issuance[0] : dayjs().add(-30, 'day').toDate();
      const finalDate = this.filters.issuance[1] ? this.filters.issuance[1] : dayjs().toDate();
      const records = await this.attendanceService.generate(
        id || this.getClientIdFromRoute(),
        this.activeClient?.prospectId || null,
        this.clientType,
        this.index,
        dayjs(initialDate).format('DD/MM/YYYY'),
        dayjs(finalDate).format('DD/MM/YYYY'),
      );
      if (records) {
        this.ordersPeriod = records;
        await Promise.all([
          this.loadItems(false),
          this.loadSummary(id || this.getClientIdFromRoute()),
        ]);
      } else {
        this.emptyItems = true;
        this.attendanceSummary = null;
      }
      await this.loadEngagementScore(id || this.getClientIdFromRoute());
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      loader.hide();
    }
  }

  onSendEmailOrder(orders: OrderModel[]): void {
    if (!orders.length) return;

    if (orders.length > this.sendOrderByEmailLimit) {
      this.$notify.error(
        `${this.$tc('crm.view.order.sendOrderByEmailLimitExceed', this.sendOrderByEmailLimit, {
          selected: orders.length,
        })}`,
      );
      return;
    }

    this.ordersToSend = orders;
    this.dialogConfig.sendOrderEmail.show = true;
  }

  infiniteScrolling(entries: IntersectionObserverEntry, observer: IntersectionObserver, isIntersecting: boolean): void {
    if (isIntersecting && !this.noMoreItems && this.items.length > 0) {
      this.loadItems(true);
    }
  }

  private getClientIdFromRoute(): string {
    if (this.clientType === ClientTypeEnum.Prospect) {
      const currentRoute = this.routerService.route();
      return currentRoute.params && currentRoute.params.clientId;
    }
    if (this.activeClient?.cnpjCpf) return this.activeClient.cnpjCpf;
    const currentRoute = this.routerService.route();
    return (currentRoute.params && currentRoute.params.clientId) || '';
  }
}
